<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page="page"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import VehiclePage from './VehiclePage'
import { repository, messageBox } from 'jtech'

const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'Vehicle',
  components: { CrudLayout, VehiclePage },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Vehicle extends Vue {
  get nmInterface () {
    return this.interface
  }

  get page () {
    return VehiclePage
  }

  async btAlterar ({ button, params, page, controller }) {
    const id = page.params ? page.params.id : params.id
    await repository.update(button.action, { ...params, id: id })
    this.$refs.crudLayout.removePage(page)
  }

  async btGravar ({ button, params, page, controller }) {
    await repository.create(button.action, params)
    if (page.limparFormVehicle) {
      page.limparFormVehicle()
      page.elements[0].dadosForm.truckWeightCapacity = null
      page.elements[0].dadosForm.weightCapacity = ''
      page.elements[0].dadosForm.carrierVehicles = []
      page.showImage = false
    }
  }

  mounted () {
    try {
      this.$refs.crudLayout.onButton('btAlterar', this.btAlterar)
      this.$refs.crudLayout.onButton('btGravar', this.btGravar)
    } catch (error) {
      console.error(error)
    }
  }
}
export default Vehicle
</script>
<style lang="stylus" scoped></style>
